exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pro-tips-button[data-v-1fd168a6]{color:#4d7cfe!important}.protips-popover[data-v-1fd168a6]{max-width:650px!important}#advanced-search-pro-tips img[data-v-1fd168a6]{height:auto;max-width:100%;max-height:100%}", ""]);

// exports
